export class Snowflake {
    constructor(canvas, options) {
        this.canvas = canvas;
        this.updateOptions(options);
        this.reset();
    }
    
    updateOptions(options) {
        this.options = options;
        this.size = Math.random() * (options.size.max - options.size.min) + options.size.min;
        this.speed = (Math.random() + 0.5) * options.speed;
    }
    
    reset() {
        this.x = Math.random() * this.canvas.width;
        this.y = -this.size;
        this.angle = Math.random() * Math.PI * 2;
        this.opacity = Math.random() * 0.5 + 0.3;
    }
    
    update() {
        this.angle += 0.01;
        this.x += Math.sin(this.angle) * this.options.wind;
        this.y += this.speed;
        
        // Reset if snowflake goes off screen
        if (this.y > this.canvas.height + this.size) {
            this.reset();
        }
        
        // Wrap horizontally
        if (this.x > this.canvas.width + this.size) {
            this.x = -this.size;
        } else if (this.x < -this.size) {
            this.x = this.canvas.width + this.size;
        }
    }
    
    draw(ctx) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size / 2, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(255, 255, 255, ${this.opacity})`;
        ctx.fill();
    }
}
